import styles from "../../Basket/ProductTileList/ProductTile.module.scss";
import stylesBasket from "../../Basket/Basket.module.scss";
import TileImage from "../../Basket/ProductTileList/ProductTile/TileImage";
import Srcset from "@/components/common/Srcset";
import stylesWishlist from "../Wishlist.module.scss";
import CTA from "../../common/CTA";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeFromWishlist } from "@/redux/actions/wishlistAction";
import { removeProductFromWishlist } from "@/helpers/wishlistHelpers";
import { addProductToCart } from "@/helpers/cartHelpers";
import { addToCart } from "@/redux/actions/addToCartAction";
import { setEstimatedShip, setGroupShipDate } from "@/helpers/checkout-shipping/checkoutShippingHelper";
import { priceFormatFunc } from "@/helpers/stringFormat";
import { showPwaLoader } from "@/redux/actions/pwaAction";
import Tooltip from "@/components/common/Tooltip";

export default function WishListProductTile({ product,device }) {
  const dispatch = useDispatch();
  const [fav, setFav] = useState(true);
  const timeout = useRef(null);
  const wishlistHash = useSelector((state) => state.wishlist.wishlistHashId);
  const wishlistItems = useSelector((state) => state.wishlist.wishlist);
  const [loading, setLoading] = useState(false);
  const [isRemoved, setIsRemoved] = useState(false); // Hide product tile after removeFromWishlist call is made
  const isPWA = useSelector((state) => state.pwa.is_PWA);

  const removeProduct = async (productVariantId) => {
    //if condition is only to prevent heart icon from disappearing after product is added to bag from wishlist and then removed from wishlist
    setLoading(true);

    // Hide product tile
    setIsRemoved(true);

    const response = await removeProductFromWishlist({
      hash: wishlistHash,
      productVariantId: productVariantId,
    });

    setLoading(false);
    if (response.ok && response.deleted) {
      const newWishlistArray = wishlistItems.filter(
        (item) => item.ProductVariantId !== productVariantId
      )
      sessionStorage.setItem("wishlist", JSON.stringify({ items: newWishlistArray }));
      dispatch(removeFromWishlist(productVariantId));
    } else {
      // Wishlist removal failed
      setFav(true);
      setIsRemoved(false);
    }
  };

  const addItemToCart = async (productVariantId, quantity) => {
    try {
      const variantId = `gid://shopify/ProductVariant/${productVariantId}`;
    //following object is created to keep wishlist, cart product data in same format
    let productObj = {};
    productObj.product = product;
    //required parameters for add to wishlist
    let request = {
      variantId: variantId,
      quantity: quantity,
      badge_curated: product.badge_curated,
      availability: product.availability,
      olivela_cost: product.olivela_cost,
      barcode: product.barcode,
      vendor: product.Vendor,
    }
    //custom attribute array at product tile level
    request.lineItemCustomAttributes = []
    //to show estimated delivery data message at product tile level
    let estimatedDeliveryDate = setGroupShipDate(productObj);
    if (estimatedDeliveryDate.property) {
      request.lineItemCustomAttributes.push(estimatedDeliveryDate.property)
    }
    let expectedShipDate = setEstimatedShip(productObj);
    if (expectedShipDate) {
      request.lineItemCustomAttributes.push(expectedShipDate)
    }
    if(device) {
      request.lineItemCustomAttributes.push({ key: "_device", value:device })
    }
    setLoading(true);
    const response = await addProductToCart(request);
    setLoading(false);
    // successful
    if (response?.id) {
      dispatch(addToCart(response));
      // Remove the product from wishlist
      removeProduct(productVariantId);
    }
    } catch (e) {
      console.log(e,"Error for add to cart from wishlist")
    }
  };

  useEffect(() => {
    if (!fav) {
      // if fav is changed to false then remove product after 3 seconds, allow user to undo removal withing these 3 seconds
      timeout.current = setTimeout(
        () => removeProduct(product.ProductVariantId),
        3000
      );
    }
    // else {
    //   clearTimeout(timeout.current);
    // }

    // Cleanup. Will also run if user undoes the removal from wishlist i.e. when fav is set to true
    return () => {
      clearTimeout(timeout.current);
    };
  }, [fav]);

  // Setting the element to be displayed for color and Size and other options if any
  let optionsDisplay = null;
  let color = null;
  if (product.Color !== "No Color") {
    color = product.Color;
  }
  let size = product.Size;
  let letter = product.Letter;

  if (color && size) {
    optionsDisplay = (
      <p className={`x-small-md xx-small-sm xx-small-xs ${stylesWishlist.sub_text}`}>
        <span>{color}</span> | <span>{size}</span>
      </p>
    );
  } 
  else if(letter && size) {
    optionsDisplay = (
      <p className={`x-small-md xx-small-sm xx-small-xs ${stylesWishlist.sub_text}`}>
        <span>{letter}</span> | <span>{size}</span>
      </p>
    );
  }
    else if (color || size || letter) {
    optionsDisplay = (
      <p className={`x-small-md xx-small-sm xx-small-xs ${stylesWishlist.sub_text}`}>
        <span>{color || size || letter}</span>
      </p>
    );
  }

  return (
    <>
      {!isRemoved && (
        <div
          className={`row ${stylesWishlist.wishlist_tile} ${styles.product_tile} ${stylesBasket.product_tile} ${loading ? "loading" : ""}`}
        >
          <div className={`${styles.image} ${stylesWishlist.image}`}>
            <TileImage url={product.ProductImage !== "no-image" ? product.ProductImage : null} href={product.ProductLink} badge_curated={product.badge_curated}/>
            <div
              className="favorite"
              id={`favorite`}
              onClick={(e) => {
                e.stopPropagation();
                if (!loading) setFav(!fav);
              }}
              tabIndex={0}
            >
              <img
                src={fav ? "/favourites-fill.svg" : "/favourites.svg"}
                width={11}
                height={10}
                alt="favourites"
              ></img>
            </div>
          </div>
          {fav && (
            <div className={`${styles.details} ${stylesWishlist.details}`}>
              <p className={`small ${stylesWishlist.product_title}`}>
                <a tabIndex={0} href={product.ProductLink} onClick={(e) => 
                  {
                    if(isPWA) {
                      dispatch(showPwaLoader(true))
                    }
                }
                }>
                {product.Vendor}
                </a>
              </p>
              <p className={`x-small ${stylesWishlist.sub_text}`}>
                <a href={product.ProductLink} onClick={(e) => 
                    {
                      if(isPWA) {
                        dispatch(showPwaLoader(true))
                      }
                  }
                  }>
                <Tooltip text={product.ProductName} />
                </a>
              </p>                
              {optionsDisplay}
              <div className={`${stylesWishlist.price_sec}`}>
                {product.FormattedSalePrice && (
                  <p
                    className={`x-small ${stylesWishlist.price} ${stylesWishlist.price_change}`}
                  >
                    <span className={`${stylesWishlist.red}`}>
                    {priceFormatFunc(product.FormattedSalePrice)}
                    </span>
                    <span className={`xx-small ${stylesWishlist.old_price}`}>
                      {product.FormattedPrice}
                    </span>
                  </p>
                )}
                {!product.FormattedSalePrice && (
                  <p className={`x-small-md x-small-sm x-small-xs bold ${stylesWishlist.price}`}>
                    {product.FormattedPrice}
                  </p>
                )}
              </div>
              <div className={` small ${stylesWishlist.cta_sec}`}>
                {product.AvailableForSale && (
                  <CTA
                    text="Add to bag"
                    link={null}
                    handleClick={() => {
                      if (!loading)
                        addItemToCart(product.ProductVariantId, "1");
                    }}
                    noPWALoader={true}
                  />
                )}
                {!product.AvailableForSale && (
                  <div className={`x-small-md x-small-sm x-small-xs ${stylesWishlist.out_of_stock}`}>
                    Out of stock
                  </div>
                )}
              </div>
            </div>
          )}
          {fav && (
            <div className={``}>
              <div
                className={`text-end ${stylesWishlist.close_wrapper}`}
                role="button"
                onClick={() => {
                  if (!loading) setFav(!fav);
                }}
              >
                <Srcset
                  requirePath={true}
                  svgFile={true}
                  src={"images/Icons/Cross/Large.svg"}
                  alt="cross-button"
                  height="12"
                  width="12"
                  layout=""
                  tabIndex={0}
                />
              </div>
            </div>
          )}
          {!fav && (
            <div className={`${styles.details} ${stylesWishlist.undo_wrap}`}>
              <p className={`small-md x-small-sm x-small-xs ${styles.product_title}`}>
                This item has been removed
              </p>
              <p className={`${styles.sub_text} ${stylesWishlist.undo_txt}`}>
                <span className="x-small-md xx-small-sm xx-small-xs"
                  onClick={() => {
                    if (!loading) setFav(true);
                  }}
                  tabIndex={0}
                >
                  Undo
                </span>
              </p>
            </div>
          )}
        </div>
      )}
    </>
  );
}
